interface SheetDriveLinksProps {
  sheetUrl: string;
  driveFolderUrl: string;
}

export function SheetDriveLinks({ sheetUrl, driveFolderUrl }: SheetDriveLinksProps) {
  return (
    <div className="sheet-drive-links">
      <a className="link-chip" href={sheetUrl} target="_blank" rel="noopener noreferrer">
        <ExternalIcon />
        Sheet
      </a>
      <a className="link-chip" href={driveFolderUrl} target="_blank" rel="noopener noreferrer">
        <ExternalIcon />
        Drive
      </a>
    </div>
  );
}

function ExternalIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M15 3h6v6" />
      <path d="M10 14 21 3" />
      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
    </svg>
  );
}
